import PropTypes from 'prop-types';
// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import {
  Box,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Switch,
} from '@mui/material';
import Iconify from '../iconify';
import TapTooltip from '../tooltip/TapTooltip';

// ----------------------------------------------------------------------

RHFSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  helperText: PropTypes.node,
  onChange: PropTypes.func,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
};

export default function RHFSwitch({
  name,
  helperText,
  onChange,
  tooltip,
  disabled = false,
  ...other
}) {
  const { control } = useFormContext();

  // Quando há tooltip, o espaço entre o label e o ícone vem do gap do Box, e a margem
  // direita padrão do FormControlLabel é zerada para o ícone não ficar distante. Antes
  // isso era feito com margem negativa no ícone, que ficava por cima do texto sempre que
  // quem usa o componente zerava a margem do label pelo sx.
  const { sx: labelSx, ...labelProps } = other;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={other.defaultValue}
      render={({ field, fieldState: { error } }) => {
        const switchComponent = (
          <Switch
            {...field}
            disabled={disabled}
            checked={Boolean(field.value)}
            onChange={(e) => {
              if (disabled) return
              field.onChange(e)
              if (onChange) onChange(e)
            }}
          />
        )

        return (
          <div>
            <Box display="flex" alignItems="center" gap={0.5}>
              <FormControlLabel
                control={switchComponent}
                disabled={disabled}
                {...labelProps}
                sx={{ ...(tooltip && { mr: 0 }), ...labelSx }}
              />

              {tooltip && (
                <TapTooltip
                  title={tooltip}
                  arrow
                  enterDelay={200}
                  leaveDelay={200}
                  disableInteractive={false}
                  PopperProps={{
                    modifiers: [{ name: 'offset', options: { offset: [0, 4] } }],
                  }}
                >
                  <IconButton size="small" sx={{ flexShrink: 0 }}>
                    <Iconify icon="eva:question-mark-circle-outline" width={18} height={18} />
                  </IconButton>
                </TapTooltip>
              )}
            </Box>

            {(!!error || helperText) && (
              <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
            )}
          </div>
        );
      }}
    />
  );
}
